import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, Btn, Card } from "@/components/cc";
import { Download } from "lucide-react";

export default function Audit() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/audit-logs", { params: { limit: 200 } }).then((r) => setLogs(r.data)).catch(() => {});
  }, []);

  const exportData = async () => {
    try {
      const { data } = await api.get("/export");
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `beapuo-export-${new Date().toISOString().slice(0, 10)}.json`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Full data export downloaded");
    } catch (err) {
      toast.error("Export failed (super admin only)");
    }
  };

  return (
    <div className="p-6">
      <PageHeader title="Audit Trail" subtitle="Immutable log of editorial and research actions.">
        <Btn data-testid="export-btn" onClick={exportData}><Download className="h-4 w-4" /> Export All Data (JSON)</Btn>
      </PageHeader>

      <Card>
        <table className="w-full text-sm" data-testid="audit-table">
          <thead>
            <tr className="text-left label-caps text-zinc-500 border-b border-zinc-800">
              <th className="px-4 py-2.5">Action</th>
              <th className="px-4 py-2.5">Entity</th>
              <th className="px-4 py-2.5">Entity ID</th>
              <th className="px-4 py-2.5">When</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-900">
            {logs.length === 0 && <tr><td colSpan={4} className="px-4 py-6 text-zinc-600">No audit entries.</td></tr>}
            {logs.map((l) => (
              <tr key={l.id} className="hover:bg-zinc-900/50">
                <td className="px-4 py-2 font-mono-data text-xs text-emerald-400 uppercase">{l.action}</td>
                <td className="px-4 py-2 text-zinc-300">{l.entity_type}</td>
                <td className="px-4 py-2 text-zinc-600 font-mono-data text-xs">{l.entity_id ? l.entity_id.slice(-8) : "—"}</td>
                <td className="px-4 py-2 text-zinc-600 font-mono-data text-xs">{l.created_at ? new Date(l.created_at).toLocaleString() : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
